
import React from 'react';
import Input from '../../../../components/ui/Input';
import { ClientProfile } from '../../../../types';

interface CompanyInfoCardProps {
    formData: ClientProfile;
    onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

export const CompanyInfoCard: React.FC<CompanyInfoCardProps> = ({ formData, onChange }) => {
    return (
        <div className="card-premium p-4">
            <h3 className="text-sm font-bold text-secondary mb-4">Informações da Empresa</h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <Input
                    name="companyName"
                    autoComplete="organization"
                    value={formData.companyName || ''}
                    onChange={onChange}
                    placeholder="Razão Social"
                />
                <Input
                    name="cnpj"
                    autoComplete="off"
                    value={formData.cnpj || ''}
                    onChange={onChange}
                    placeholder="CNPJ"
                />
            </div>
        </div>
    );
};
